{
  "validation": {
    "vatNumber": {
      "empty": "EXAMPLE: Please, enter the VAT NUMBER",
      "not_positive": "EXAMPLE: the max length is {{maxLength}} of field {{field}}",
      "invalid_email": "EXAMPLE: $t(rules.empty, { 'field': {{field, lowercase}} })"
    }
  },
  "rules": {
    "empty": "{{field}} is required",
    "duplicate_name": "This Name is already taken",
    "length": "Length of {{field}} should be {{length}} characters",
    "min_length": "Min length of {{field}} is {{minLength}} characters",
    "max_length": "Max length of {{field}} is {{maxLength}} characters",
    "invalid": "Name should begin with a letter and end with a letter or digit. May include spaces, dots and dashes.",
    "trailing_whitespace": "Remove trailing whitespace",
    "beginning_whitespace": "Remove beginning whitespace",
    "invalid_email": "Enter a valid email",
    "invalid_password": "Password must contain at least 8 characters, one uppercase letter, one lowercase letter and a digit",
    "passwords_no_match": "Passwords do not match",
    "after_max_date": "{{field}} should not be after {{maxDate}}",
    "before_min_date": "{{field}} should not be before {{minDate}}",
    "invalid_date": "Invalid date format",
    "invalid_time": "Invalid time format",
    "later_than": "{{field}} should be later than {{laterThan}}",
    "not_positive": "{{field}} should be positive",
    "more_than": "{{field}} should be greater than {{moreThan}}",
    "less_than": "{{field}} should be less than {{lessThan}}",
    "more_than_or_equal": "{{field}} should be greater than or equal to {{moreThan}}",
    "less_than_or_equal": "{{field}} should be less than or equal to {{lessThan}}",
    "illegal_property": "Illegal property",
    "integer": "{{field}} should be a whole number",
    "invalid_url": "The provided URL is not valid, ensure it follows the correct format (e.g., https://example.com)",
    "invalid_domain": "Enter a valid domain",
    "unique_arr": "{{field}} should contain only unique values",
    "max_arr_length": "{{field}} should contain only {{maxLength}} values",
    "subnet_mask_not_valid": "Invalid network address (valid format: 10.0.0.4/16)",
    "either_or": "Either provide {{field}} or {{field2}}"
  }
}
